
import image from '@images/examples/kaarsje-resormeren.png'
import CallToAction from "@/Molecules/CallToAction/CallToAction";
import React from "react";

export default function Onboarding() {

  return <CallToAction
    imageBackground={image}
    title={'Vrijblijvende afspraak inplannen?'}
    content={<>
      <p>Het <strong>gratis</strong> online condoleanceregister van Mensenlinq
        op jouw website laten implementeren? Meerdere
        uitvaartondernemers gingen je voor! Plan een
        vrijblijvende afspraak in via <a href={'mailto:info@mensenlinq.nl'}>info@mensenlinq.nl</a> of via
        onderstaande knop.</p>
      {/*<a className="button" href={relativeRoute('contact')}>Afspraak inplannen</a>*/}
      <a className="button" href={'https://forms.office.com/e/sE5fZgtB91'}>Afspraak inplannen</a>
    </>}
  />


}
